module.exports = __webpack_public_path__ + "static/media/brand-refresh-Minus.34bfb3ec.svg";